import { action } from './index';

export const LOAD_FILTERED_DATA = 'LOAD_FILTERED_DATA';
export const requestLoadFilteredData = data => action(LOAD_FILTERED_DATA, data);

export const SET_FILTER = 'SET_FILTER';
export const setFilter = filter => action(SET_FILTER, filter);
